import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

// Quick-select tiles for a short list of common values, with an "Other…" escape hatch that
// reveals a free-text field — the field stays free text on the backend (no enum), this is purely
// a faster way to fill it in than typing every time.

export default function TileSelect({ options, value, onChange, otherPlaceholder = 'Type your own…', idPrefix = 'tile' }) {
  const isKnown = !value || options.includes(value);
  const [customMode, setCustomMode] = useState(!!value && !isKnown);

  return (
    <div>
      <div className="d-flex flex-wrap gap-2 mb-2">
        {options.map((opt) => (
          <Button
            key={opt}
            type="button"
            size="sm"
            variant={!customMode && value === opt ? 'primary' : 'outline-secondary'}
            onClick={() => { setCustomMode(false); onChange(opt); }}
          >
            {opt}
          </Button>
        ))}
        <Button
          type="button" size="sm"
          variant={customMode ? 'primary' : 'outline-secondary'}
          onClick={() => setCustomMode(true)}
        >
          Other…
        </Button>
      </div>
      {customMode && (
        <Form.Control
          id={`${idPrefix}-other`}
          size="sm"
          placeholder={otherPlaceholder}
          value={isKnown ? '' : value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  );
}
